import * as React from "react";
import { ListSelection, SimpleList } from "azure-devops-ui/List";
import { ArrayItemProvider } from "azure-devops-ui/Utilities/Provider";
import { Card } from "azure-devops-ui/Card";

export default class NonScrollableListExample extends React.Component {
    private selection = new ListSelection(true);
    public render(): JSX.Element {
        return (
            <Card>
                <SimpleList
                    itemProvider={
                        new ArrayItemProvider<string>(["Row 1", "Row 2", "Row 3", "Row 4", "Row 5"])
                    }
                    selection={this.selection}
                    onSelect={(event, data) => console.log("Select Row - " + data.index)}
                />
            </Card>
        );
    }
}
